<template>
  <div>
    <div class="search_group">
      <el-date-picker v-model="searchTime" type="monthrange" value-format="yyyy-MM" size="small" ange-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"></el-date-picker>
      <el-button @click="searchAct" icon="el-icon-search" size="small" type="success">查询</el-button>
    </div>
    <el-table :max-height="tableHeight"
      v-loading="listLoading" element-loading-text="加载中" border :data="tableData"
      >
      <el-table-column align="center"  prop="month" label="月份" width="200"></el-table-column>
      <el-table-column align="center"  prop="scope" label="结算版本" width="200">
        <template slot-scope="scope">{{ 'V' + scope.row.version }}</template>
      </el-table-column>
      <el-table-column align="right"  prop="totalMoney" label="结算金额（元）" ></el-table-column>
      <el-table-column align="right"  prop="totalCpm" label="结算量（CPM）"></el-table-column>
      <el-table-column align="center"  fixed="right" width="100" label="操作">
        <template slot-scope="scope">
          <el-button @click="openDetail(scope.row)" icon="el-icon-info" size="mini" type="text">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
      </el-pagination>
    </div>
    <projectDetail :projectDetailFlag.sync="projectDetailShow" :projectInfo="rowData"></projectDetail>
  </div>
</template>
<script>
import { getSettlementList } from '@/api/projectSettlement/summary'
import pagination from '@/util/mixins/pagination'
import projectDetail  from '../dialogs/projectDetail.vue'
export default {
  mixins: [pagination],
  data () {
    return {
      tabs: '0',
      status: '',
      // 老乐播云数据
      oData: {
        token: this.$route.query.t,
        tid: this.$route.query.tid,
        name: this.$route.query.name
      },
      userAccount: '', // 用户账户
      searchTime: '', // 时间
      selectProject: [], // 选择的项目列表
      showDetails: false, // 详情弹窗
      showAddDialog: false, // 结算弹窗
      editId: '', // 传入编辑弹框id
      editRow: {},
      editType: '', // 传入编辑弹框类型
      rowData: {}, // 查看的详情数据
      projectProcedureShow: false, // 项目结算过程弹窗
      projectDetailShow: false // 项目结算详情弹窗
    }
  },
  components: {
    projectDetail,
},
  mounted () {
    this.getList()
  },
  methods: {
    // 打开弹窗查看详情
    openDetail (row) {
      this.rowData = row
      this.projectDetailShow = true
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        startDate: this.searchTime ? this.searchTime[0] : '',
        endDate: this.searchTime ? this.searchTime[1] : '',
        status: 4,
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      getSettlementList(postData, this.oData).then(onSuccess).catch(() => { this.listLoading = false })
    }
  }
}
</script>
